'use client';

import { useGeolocated } from 'react-geolocated';
import { useEffect, useState } from 'react';
import type { UserGeolocation } from '../types';

export const useGeolocation = () => {
    const { coords, isGeolocationEnabled } = useGeolocated({
        positionOptions: {
            enableHighAccuracy: false,
        },
        suppressLocationOnMount: true,
        userDecisionTimeout: 5000,
    });

    const [userLocation, setUserLocation] = useState<UserGeolocation | null>(
        null
    );

    useEffect(() => {
        if (isGeolocationEnabled && coords) {
            setUserLocation({ lat: coords.latitude, lng: coords.longitude });
        }
    }, [coords, isGeolocationEnabled]);

    return userLocation;
};
